export { default as SettingService } from './setting'
export { default as ContentService } from './content'
export { default as HeaderService } from './header'
export { default as AuthenService } from './authen'
export { default as SlideService } from './slide'
export { default as TinTucService } from './tinTuc'
export { default as GalleryService } from './gallery'
export { default as SuKienService } from './suKien'
